var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDeals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42773 3.28599C1.42773 2.49702 2.06733 1.85742 2.85631 1.85742H28.5706C29.3596 1.85742 29.9992 2.49702 29.9992 3.28599V34.7146C29.9992 35.5035 29.3596 36.1431 28.5706 36.1431H2.85631C2.06733 36.1431 1.42773 35.5035 1.42773 34.7146V3.28599ZM2.85631 2.57171C2.46182 2.57171 2.14202 2.8915 2.14202 3.28599V34.7146C2.14202 35.109 2.46182 35.4288 2.85631 35.4288H28.5706C28.9651 35.4288 29.2849 35.109 29.2849 34.7146V3.28599C29.2849 2.8915 28.9651 2.57171 28.5706 2.57171H2.85631Z",
    fill: "#807E8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7129 10.4291H15.7129V9.71484H25.7129V10.4291Z",
    fill: "#807E8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4272 16.143H15.7129V15.4287H21.4272V16.143Z",
    fill: "#807E8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7129 21.8578H15.7129V21.1436H25.7129V21.8578Z",
    fill: "#807E8D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9986 27.5717H15.7129V26.8574H19.9986V27.5717Z",
    fill: "#807E8D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8569 11.8571C12.8569 13.4351 11.5777 14.7143 9.99972 14.7143C8.42176 14.7143 7.14258 13.4351 7.14258 11.8571C7.14258 10.2792 8.42176 9 9.99972 9C11.5777 9 12.8569 10.2792 12.8569 11.8571ZM9.99972 14C11.1832 14 12.1426 13.0406 12.1426 11.8571C12.1426 10.6737 11.1832 9.71429 9.99972 9.71429C8.81625 9.71429 7.85686 10.6737 7.85686 11.8571C7.85686 13.0406 8.81625 14 9.99972 14Z",
    fill: "#807E8D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90704 16.5951C7.73455 16.0864 8.82174 15.7861 9.99833 15.7861C11.2425 15.7861 12.385 16.1217 13.2269 16.683C13.5421 16.8931 13.8198 17.1387 14.0437 17.4134C14.1842 17.5857 14.3035 17.7694 14.3977 17.963C14.4488 18.0678 14.4925 18.1757 14.5282 18.2861C14.5667 18.4053 14.5958 18.5276 14.6149 18.6526C14.6322 18.7663 14.6412 18.8823 14.6412 19.0004H13.9269C13.9269 18.3687 13.5432 17.7523 12.8307 17.2773C12.742 17.2182 12.6488 17.1617 12.5514 17.1082C11.8695 16.7332 10.9808 16.5004 9.99833 16.5004C8.7828 16.5004 7.71284 16.8566 6.9993 17.3955C6.46885 17.7962 6.155 18.2797 6.08483 18.7835C6.07481 18.8554 6.06975 18.9278 6.06975 19.0004H5.35547L5.35547 18.9982C5.35571 18.7511 5.39529 18.513 5.46861 18.2861C5.65253 17.717 6.04874 17.2184 6.56878 16.8256C6.6759 16.7446 6.78882 16.6677 6.90704 16.5951Z",
    fill: "#807E8D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.856 34.7147L32.856 3.28613L33.5703 3.28613L33.5703 34.7147L32.856 34.7147Z",
    fill: "#807E8D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.35547,
    y: 19,
    width: 9.28571,
    height: 0.714287,
    fill: "#807E8D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDeals);
export default __webpack_public_path__ + "static/media/no-deals.bfa2ec3f.svg";
export { ForwardRef as ReactComponent };